import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Status from "../views/Status.vue";
Vue.use(VueRouter);
import store from '../store';

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (store.state.isAuthenticated || store.state.isLoading) {
    next()
    return
  }
  next('/signin')
}


const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Status",
    beforeEnter: ifAuthenticated,
    component: Status
  },
  {
    path: "/status",
    name: "Status",
    beforeEnter: ifAuthenticated,
    component: Status
  },
  {
    path: "/free-status-text",
    name: "Vrije teksten",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FreeStatusText.vue")
  },
  {
    path: "/platform-preferences",
    name: "Platform preference",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PlatformPreference.vue")
  },
  {
    path: "/platform-control",
    name: "Platform control",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PlatformStatus.vue")
  },
  {
    path: "/signin",
    name: "Log in",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignIn.vue")
  },
  
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
